import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';

import { PublicViewer } from '../features/viewer/public-viewer';

/**
 * Layout route for the public Viewer. The Viewer lives here rather than in each
 * child so that navigating between Slides pushes a canonical URL without
 * remounting the runtime, bootstrap query or narration element.
 */
export const Route = createFileRoute('/p/$shareId')({ component: ViewerLayout });

function ViewerLayout() {
  const { shareId } = Route.useParams();
  // The Slide segment belongs to a child match, so it is read from the deepest
  // match rather than from this route's own params.
  const slidePublicId = useRouterState({
    select: (state) =>
      (state.matches.at(-1)?.params as { slidePublicId?: string } | undefined)?.slidePublicId,
  });

  return (
    <>
      <PublicViewer shareId={shareId} slidePublicId={slidePublicId} />
      <Outlet />
    </>
  );
}
